const contact = {
  title: "Let's Connect",
  description: 'Welcome to my contact page! I invite you to reach out and connect with me to explore potential collaborations, exciting opportunities, or simply to engage in meaningful conversations about art, technology, and everything in between. I look forward to hearing from you and discovering how we can create something incredible together.',
};

export default contact;
